export const TRANSLATIONS_HOME = {
  title: 'home.calendar.title',
  noActivities: 'home.calendar.no_activities',
  shortCuts: 'home.shortcuts.index',
  shortCutsP2p: 'home.shortcuts.p2p',
  shortCutsPayment: 'home.shortcuts.payment',
  buttonMoreInfo: 'button.more_information',
  buttonRetry: 'button.retry',
  errorMessageTitle: 'csp.loading_error.title',
  emptyMessageDescription: 'csp.empty_state.subtitle',
  modalErrorData: 'modal.error.load_data',
  metricsEmptyState: 'metrics.empty_state.subtitle',
  metricsTitle: 'home.metric.title',
  metricsDescription: 'home.metric.description',
  buttonSend: 'button.send',
  chart: {
    active: 'csp.active_plural',
    inactive: 'csp.inactive_plural'
  },
  firstLoginModal: {
    title: 'home.first_login_modal.title',
    subtitle: 'home.first_login_modal.subtitle',
    button: 'home.first_login_modal.button',
    planDescriptionHeading: 'home.first_login_modal.plan_description_heading',
    planName: 'home.first_login_modal.plan_name',
    planDescription: 'home.first_login_modal.plan_description',
    benefits: {
      healthcareTitle: 'home.first_login_modal.benefits.healthcare_title',
      healthcareDescription: 'home.first_login_modal.benefits.healthcare_description',
      wellbeingTitle: 'home.first_login_modal.benefits.wellbeing_title',
      wellbeingDescription: 'home.first_login_modal.benefits.wellbeing_description',
      platformTitle: 'home.first_login_modal.benefits.platform_title',
      platformDescription: 'home.first_login_modal.benefits.platform_description'
    }
  },
  collaboratorsCard: {
    active: {
      title: 'home.collaborators_card.active.title',
      description: 'home.collaborators_card.active.description',
      button: 'home.collaborators_card.active.button'
    },
    pending: {
      title: 'home.collaborators_card.pending.title',
      description: 'home.collaborators_card.pending.description',
      button: 'button.go_collaborators'
    },
    invited: {
      title: 'home.collaborators_card.invited.title',
      description: 'home.collaborators_card.invited.description',
      button: 'home.collaborators_card.invited.button'
    }
  },
  error: {
    payment: {
      title: 'home.payment.error.title',
      description: 'home.payment.error.description',
      buttonText: 'button.understood'
    }
  },
  migrationBanner: {
    text: 'banner.migration.text',
    button: 'button.learn_more'
  },
  upgradeModal: {
    title: 'upgrade_modal.teaser.title',
    description: 'upgrade_modal.upsell.description',
    learnMore: 'button.learn_more',
    close: 'button.close'
  },
  planModal: {
    title: 'upgrade_modal.upsell.title',
    description: 'upgrade_modal.upsell.description',
    primaryButton: 'upgrade_modal.upsell.primary_button',
    secondaryButton: 'upgrade_modal.upsell.secondary_button'
  },
  modalBannerFirstLogin: {
    title: 'banner_modal_first_login.title',
    title2: 'banner_modal_first_login.title2',
    title3: 'banner_modal_first_login.title3',
    subtitle: 'banner_modal_first_login.subtitle',
    subtitle2: 'banner_modal_first_login.subtitle2',
    subtitle3: 'banner_modal_first_login.subtitle3',
    button: 'button.back'
  },
  metricsCard: {
    title: 'csp.collaborators.index'
  },
  rankingCard: {
    title: 'home.ranking_card.title',
    collaborators: 'global.collaborators_title',
    emptyState: {
      emptyStateTitle: 'home.ranking_benefits_card.empty_state.title',
      emptyStateDescription: 'home.ranking_benefits_card.empty_state.description',
      emptyStateButton: 'home.ranking_card.empty_state.button'
    }
  },
  betterfliesRankingCard: {
    title: 'global.betterflies_ranking_historical.title',
    valueText: '',
    emptyState: {
      emptyStateTitle: 'global.betterflies_ranking_historical.empty_state.title',
      emptyStateDescription: 'global.betterflies_ranking_historical.empty_state.description'
    }
  },
  onboardingCard: {
    title: 'global.collaborators.title'
  },
  quickAccess: {
    title: 'home.shortcuts.title',
    report: {
      default: 'home.shortcuts.report',
      rf: 'home.rf.shortcuts.reports'
    },
    collaborators: 'home.shortcuts.collaborators',
    plan: 'home.shortcuts.plan',
    billing: 'home.shortcuts.billing',
    requests: 'home.shortcuts.requests'
  },
  navigationCard: {
    stories: 'home.shortcuts.stories',
    challenges: 'home.shortcuts.challenges'
  },
  collaboratorsToAddModal: {
    title: 'pending_collaborators.notify.dialog.title',
    description: 'pending_users.notify.dialog.description',
    button: 'global.button.check_collaborators'
  },
  balanceCard: {
    main: 'global.balance_available.main',
    button: 'global.recharge.main',
    balance: {
      info: 'global.rf.balance_card.info.default',
      alert: 'global.rf.balance_card.info.balance_alert',
      negative: 'global.rf.balance_card.info.balance_negative'
    },
    error: {
      title: 'global.service_error.title',
      description: 'global.service_error.description'
    }
  },
  expensesCard: {
    title: 'global.rf.expenses_card.title',
    lastCycle: 'global.last_cycle.main',
    currentCycle: 'global.current_cycle.main',
    onlyCycle: 'rf.global.expenses_savings_card.cycle_indicator',
    categories: {
      restaurant: 'global.rf.benefit_title.restaurant',
      transport: 'global.rf.benefit_title.transport',
      healthInsurance: 'global.rf.benefit_title.health_insurance',
      daycare: 'global.rf.benefit_title.daycare',
      learning: 'global.rf.benefit_title.learning'
    },
    emptyState: {
      emptyStateTitle: 'rf.global.expenses.empty_state.title',
      emptyStateDescription: 'rf.global.expenses.empty_state.description'
    }
  },
  expensesSavingsCard: {
    title: 'global.rf.expenses_savings_card.title',
    lastCycle: 'global.last_cycle.main',
    currentCycle: 'global.current_cycle.main',
    onlyCycle: 'rf.global.expenses_savings_card.cycle_indicator',
    totalExpenses: 'global.total_expenses.main',
    totalSavings: 'global.total_savings.main',
    expenses: 'global.expenses.main',
    savings: 'global.savings.main',
    forecastedConsumption: 'global.forecasted_consumption.main',
    forecastedSavings: 'global.forecasted_savings.main',
    tooltip: {
      expenses: 'rf.global.expenses_savings_card.tooltip_expenses',
      savings: 'rf.global.expenses_savings_card.tooltip_savings',
      forecast: {
        expenses: 'rf.global.forecasted_expenses_savings_card.tooltip_expenses',
        savings: 'rf.global.forecasted_expenses_savings_card.tooltip_savings'
      }
    },
    emptyState: {
      emptyStateTitle: 'rf.global.expenses.empty_state.title',
      emptyStateDescription: 'rf.global.expenses.empty_state.description'
    }
  },
  emptyHome: {
    learnMoreCard: {
      title: 'global.prepare_for_betterfly.main',
      description: 'global.go_to_helpcenter.description'
    },
    pendingPortalCard: {
      title: 'global.pending_portal.card.title',
      description: 'pending_portal.card_home.description',
      contactUs: 'global.contact_us.description'
    }
  }
};
